import { FC, memo } from 'react';

import CustomInfo from 'application/pages/StreamPage/renderer/CustomInfo/CustomInfo';
import { HELP_CENTER_CONTRACTS_LINK, TARIFFS } from 'application/pages/constants';
import { TEXTS } from 'application/pages/texts';
import { CompanyUtils } from '@entities/company';
import { useAccountCompanyPricePlan } from 'application/hooks';
import { useUserFeaturesOnboarding } from '@entities/media';

import { UserFeatures } from '@shared/api/graphql/generated';

import styles from './index.module.scss';

interface PopularTariffWarningProps {
  isStreamPage: boolean;
}

const PopularTariffWarning: FC<PopularTariffWarningProps> = ({ isStreamPage }) => {
  const { items: userOnboardingFeatures, loading: userOnboardingFeaturesLoading } = useUserFeaturesOnboarding({
    features: [UserFeatures.WarningStreamFirstStart],
  });
  const companyPricePlan = useAccountCompanyPricePlan();

  const isPopularTariff = CompanyUtils.compareTariff(companyPricePlan?.alias ?? '', TARIFFS.POPULAR);

  const isCustomInfoShouldShow = !userOnboardingFeatures?.[0]?.isOnboarded && isPopularTariff && isStreamPage;

  if (isCustomInfoShouldShow && userOnboardingFeaturesLoading) {
    return <div className={styles.skeleton} />;
  }

  if (isCustomInfoShouldShow && !userOnboardingFeaturesLoading) {
    return (
      <CustomInfo
        textObject={TEXTS.MODAL_INFO}
        link={HELP_CENTER_CONTRACTS_LINK}
      />
    );
  }

  return null;
};

export default memo(PopularTariffWarning);
